import { generateId } from '../../utils';
import { eventEmitter as em } from '../event-emitter';
import { isJSModuleWithDefaultExport } from './utils';
export function JSResource(loader, opts) {
  const {
    moduleId,
    moduleName
  } = opts;
  const listeners = new Set();
  let promise;
  let state = {
    type: 'init'
  };
  function createOnLoad(event) {
    return module => {
      em.emit('jsresource.load.complete', event);
      state = {
        type: 'module',
        module
      };
      for (const listener of listeners) {
        listener.onLoad(module);
      }
    };
  }
  function createOnError(event) {
    return error => {
      em.emit('jsresource.load.error', {
        ...event,
        error
      });
      state = {
        type: 'error',
        error
      };
      for (const listener of listeners) {
        var _listener$onError;
        (_listener$onError = listener.onError) === null || _listener$onError === void 0 ? void 0 : _listener$onError.call(listener, error);
      }
    };
  }
  return {
    getModuleId() {
      return moduleId;
    },
    getModuleName() {
      return moduleName;
    },
    getModuleIfRequired() {
      if (state.type === 'error') {
        throw state.error;
      }
      return state.type === 'module' ? state.module : null;
    },
    load() {
      if (!promise) {
        const event = {
          moduleId,
          transactionId: generateId()
        };
        const onError = createOnError(event);
        const onLoad = createOnLoad(event);
        em.emit('jsresource.load.start', event);
        try {
          promise = loader().then(result => {
            const module = isJSModuleWithDefaultExport(result) ? result.default : result;
            onLoad(module);
            return module;
          }).catch(error => {
            onError(error);
            throw error;
          });
        } catch (error) {
          if (error instanceof Error) {
            onError(error);
          }
          promise = Promise.reject(error);
        }
      }
      return promise;
    },
    onComplete(onLoad, onError) {
      if (state.type === 'module') {
        onLoad(state.module);
        return () => {};
      }
      if (state.type === 'error') {
        onError === null || onError === void 0 ? void 0 : onError(state.error);
        return () => {};
      }
      const listener = {
        onError,
        onLoad
      };
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    }
  };
}